import React from 'react'
import { Button } from '@mui/material'

export default function ErrorButton({startIcon,buttonTitle,onClick , width}) {
  return (
    <Button
            variant="contained"
            startIcon={startIcon?startIcon:""}
             onClick={onClick}
            sx={{
              borderRadius: "8px",
              fontSize: "16px",
              fontWeight: 600,
              textTransform: "none",
              backgroundColor: "#572575",
              px:3,
                width: {width},
              "&:hover": {
                backgroundColor: "#572575",
              },
            }}
          >
            {buttonTitle}
          </Button>
  )
}
